import { useMutation, useQueryClient } from "@tanstack/react-query";
import { postVacancyApplication } from "../api/vacancyApi";
import { vacancyKeys } from "../api/vacancyKeys";

// Postula un candidato; invalida el listado de postulaciones al terminar.
export const usePostulateCandidate = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: postVacancyApplication,
    onSuccess: () => qc.invalidateQueries({ queryKey: vacancyKeys.applications() }),
  });
};
